module.exports = __webpack_public_path__ + "static/logo-60afd69b0c07563150198cfdec4098f6.png";